
import {map, take} from 'rxjs/operators';
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import * as reducer from "../../reducers";
import { VerifyEmailAction, GenerateVerifyEmailAction, LogoutAction } from "../../actions/authentication";
import { Credentials } from "../../models/user";


@Component({
    selector: 'hc-auth-verify-page',
    template: `
        <div class="page">
            <div class="page__header">
                <hc-simple-header></hc-simple-header>
            </div>
            <div class="page__content verify-page">

                <div class="instruction-wrapper">
                    <svg class="letter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130"><defs><style>.cls-1{fill:#fff;}.cls-2{fill:#1af;}</style></defs><title>email</title><g id="Layer_2" data-name="Layer 2"><rect class="cls-1" x="5" y="45.96" width="119.55" height="53.52"/><path class="cls-1" d="M5,46.38,61.64,6.17a6.34,6.34,0,0,1,7.33,0l56.81,40.22"/><path d="M125.78,47.5a1.14,1.14,0,0,1-.65-.21L68.31,7.08a5.22,5.22,0,0,0-6,0L5.65,47.29a1.12,1.12,0,1,1-1.3-1.83L61,5.25a7.45,7.45,0,0,1,8.62,0l56.82,40.21A1.12,1.12,0,0,1,126.7,47,1.11,1.11,0,0,1,125.78,47.5Z"/><path class="cls-2" d="M109.17,57.52v-40a6.07,6.07,0,0,0-6.07-6.07H27.5a6.07,6.07,0,0,0-6.07,6.07v40L60.44,86a8.39,8.39,0,0,0,9.9,0Z"/><path d="M109.17,58.64A1.13,1.13,0,0,1,108,57.52v-40a4.94,4.94,0,0,0-4.94-4.94H27.5a4.94,4.94,0,0,0-4.94,4.94v40a1.13,1.13,0,0,1-2.25,0v-40a7.19,7.19,0,0,1,7.19-7.19h75.6a7.19,7.19,0,0,1,7.19,7.19v40A1.12,1.12,0,0,1,109.17,58.64Z"/><path class="cls-1" d="M81.7,57.66h0a1.82,1.82,0,0,1,1.41,3A15.12,15.12,0,0,1,79,64,23.28,23.28,0,0,1,67.5,66.6a26.58,26.58,0,0,1-11.32-2.22,14.88,14.88,0,0,1-7.1-6.53,19.55,19.55,0,0,1-2.32-9.41A21.33,21.33,0,0,1,49.4,38a17.29,17.29,0,0,1,7.23-7.22A22.2,22.2,0,0,1,67.12,28.4a19.62,19.62,0,0,1,8.9,2,13.81,13.81,0,0,1,6,5.53,15.48,15.48,0,0,1,2,7.84,14.76,14.76,0,0,1-3.11,9.15,12.06,12.06,0,0,1-10,5.17,4.35,4.35,0,0,1-2.48-.58,2.75,2.75,0,0,1-1.11-1.69A7.54,7.54,0,0,1,61.88,58a7.26,7.26,0,0,1-5.48-2.28,8.37,8.37,0,0,1-2.17-6,14.8,14.8,0,0,1,2.62-8.52Q60,36.51,65,36.51a5.73,5.73,0,0,1,5.22,2.7l0-.19a2.59,2.59,0,0,1,2.52-2h0a2.58,2.58,0,0,1,2.52,3.11L73,51.24A12.85,12.85,0,0,0,72.68,53a1.1,1.1,0,0,0,.23.75.73.73,0,0,0,.55.25,4.56,4.56,0,0,0,2.46-1.16,11,11,0,0,0,3.28-4,11.82,11.82,0,0,0,1.25-5.26,10.72,10.72,0,0,0-3.54-8.18Q73.39,32.05,67,32.06a17.81,17.81,0,0,0-9.13,2.19,14,14,0,0,0-5.64,6.18,19.1,19.1,0,0,0-1.89,8.29,14.25,14.25,0,0,0,2.11,7.63,12.35,12.35,0,0,0,5.94,5,22.83,22.83,0,0,0,8.75,1.57,22.62,22.62,0,0,0,8.16-1.32,12.8,12.8,0,0,0,5-3.39A1.79,1.79,0,0,1,81.7,57.66ZM59.37,49.5a5.55,5.55,0,0,0,1,3.71,3.18,3.18,0,0,0,2.53,1.19,4.27,4.27,0,0,0,2.12-.55,5.22,5.22,0,0,0,1.49-1.25,10.21,10.21,0,0,0,1.82-3.54,13.91,13.91,0,0,0,.77-4.33,5.08,5.08,0,0,0-1-3.45,3.33,3.33,0,0,0-2.63-1.2,4.61,4.61,0,0,0-3.16,1.32,8.19,8.19,0,0,0-2.18,3.77A15.22,15.22,0,0,0,59.37,49.5Z"/><path class="cls-1" d="M125.78,125H5V46.38l56.64,40.2a6.34,6.34,0,0,0,7.33,0l56.81-40.21Z"/><path d="M125.78,126.13H5A1.14,1.14,0,0,1,3.87,125V46.38a1.13,1.13,0,0,1,.61-1,1.1,1.1,0,0,1,1.17.08L62.29,85.67a5.23,5.23,0,0,0,6,0l56.82-40.21a1.13,1.13,0,0,1,1.78.92V125A1.13,1.13,0,0,1,125.78,126.13ZM6.12,123.88H124.66V48.55l-55,39a7.47,7.47,0,0,1-8.62,0L6.12,48.55Z"/><path d="M125.78,126.13a1.08,1.08,0,0,1-.73-.28l-50.16-43a1.12,1.12,0,0,1,1.46-1.71l50.17,43a1.13,1.13,0,0,1-.74,2Z"/><path d="M5,126.13a1.13,1.13,0,0,1-.73-2l50.16-43a1.13,1.13,0,1,1,1.47,1.71l-50.17,43A1.08,1.08,0,0,1,5,126.13Z"/></g></svg>

                    <div class="lead-in">
                        <h1 class="lead-in__heading lead-in__heading--centered lead h2 qa-verify-welcome-subtitle" translate>Check deine E-Mail</h1>
                    </div>

                    <p>
                        {{ "Klick auf den Link in der E-Mail, die du von uns auf" | translate }}
                        <strong>{{email$ | async}}</strong>{{ " erhalten hast" | translate}}.
                    </p>

                    <div class="no-email-received">

                        <p translate>Du hast keine E-Mail erhalten?</p>
                        <hc-verify-email (submitForm)="verify($event)"
                                         (submitGenerateVerificationCode)="generateVerificationCode($event)"></hc-verify-email>
                    </div>

                    <a class="verify-page__back-button link--tertiary" (click)="logout()" translate>
                        Zurück zur Startseite
                    </a>
                </div>
            </div>
        </div>
    `
})
export class VerifyPage {
    user$: Observable<any>;
    public email$: Observable<string>;
    anonymous$: Observable<any>;
    logginIn$: Observable<any>;

    constructor(private store: Store<reducer.AppState>,
                private router: Router) {
        /**
         * Selectors can be applied with the `let` operator, which passes the source
         * observable to the provided function. This allows us an expressive,
         * composable technique for creating view projections.
         *
         * More on `let`: https://gist.github.com/btroncone/d6cf141d6f2c00dc6b35#let
         * More on selectors: https://gist.github.com/btroncone/a6e4347326749f938510#extracting-selectors-for-reuse
         */
        this.anonymous$ = store.select(reducer.getAuthUser).pipe(take(1));
        this.logginIn$ = store.select(reducer.getAuthLogginIn);
        this.user$ = store.select(reducer.getAuthUser);
        this.email$ = this.user$.pipe(map(user => user.email));

    }

    verify(code: string) {
        this.store.dispatch(new VerifyEmailAction(code));
    }

    generateVerificationCode(verifyObj: Credentials) {
        this.store.dispatch(new GenerateVerifyEmailAction());
    }

    logout() {
        this.store.dispatch(new LogoutAction(true));
        this.router.navigate([ '' ]);
    }
}
